import { Logging } from "@/data/util/Logging";

export function logError(e) {
    Logging.LogError(e);
}

export function isRequestAbortedError(e) {
    return e?.name == "AbortError";
}
